import { inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { Endpoints } from '../../rcr-exchange/services/endpoints';
import { CdxApiGatewayHttpService } from '../../shared/services/cdx-api-gateway-http.service';

@Injectable({
  providedIn: 'root',
})
export class ReportServiceService {
  private http = inject(CdxApiGatewayHttpService);

  public rcrVolumeSummaryReport(date: any): Observable<object> {
    return this.http.post(Endpoints.RCR_VOLUME_REPORT_ENDPOINT, date);
  }

  public stContactDetailsReport(): Observable<object> {
    return this.http.post(Endpoints.CONTACT_REPORT_ENDPOINT, '{}');
  }
}
